import { useCallback, useEffect, useState } from "react";

import {
    getNoticias,
    getNoticiasPublicas,
    obtenerNoticiaPorTitulo,
    crearNoticia as crearNoticiaService,
    actualizarNoticia as actualizarNoticiaService,
    eliminarNoticia as eliminarNoticiaService,
} from "../Services/Noticias";

export const useNoticiasPublicas = () => {

    const [noticias, setNoticias] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(null);


    const cargarNoticiasPublicas = useCallback(async () => {

        try {

            setLoading(true);
            setError(null);

            const response =
                await getNoticiasPublicas();

            setNoticias(
                response.data || []
            );

        } catch (error) {

            console.error(
                "Error al cargar noticias públicas:",
                error
            );

            setError(
                error.response?.data?.message ||
                "No se pudieron cargar las noticias."
            );

        } finally {

            setLoading(false);

        }

    }, []);


    useEffect(() => {

        cargarNoticiasPublicas();

    }, [cargarNoticiasPublicas]);


    return {

        noticias,

        loading,

        error,

        cargarNoticiasPublicas,

    };

};

export const useNoticiaTitulo = (titulo) => {

    const [noticia, setNoticia] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {

        if (!titulo) return;


        const cargarNoticia = async () => {

            try {

                setLoading(true);
                setError(null);

                const data =
                    await obtenerNoticiaPorTitulo(titulo);

                console.log("NOTICIA RECIBIDA:", data);

                setNoticia(data);

            } catch (err) {

                console.error(
                    "ERROR NOTICIA:",
                    err
                );

                setError(err);

            } finally {

                setLoading(false);

            }

        };


        cargarNoticia();

    }, [titulo]);


    return {
        noticia,
        loading,
        error,
    };

};

const useNoticias = () => {

    const [noticias, setNoticias] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(null);


    /*
    |--------------------------------------------------------------------------
    | OBTENER NOTICIAS
    |--------------------------------------------------------------------------
    */

    const cargarNoticias = useCallback(async () => {

        try {

            setLoading(true);
            setError(null);

            const response = await getNoticias();

            setNoticias(response.data || []);

        } catch (error) {

            console.error(
                "Error al cargar noticias:",
                error
            );

            setError(
                error.response?.data?.message ||
                "No se pudieron cargar las noticias."
            );

        } finally {

            setLoading(false);

        }

    }, []);


    /*
    |--------------------------------------------------------------------------
    | CREAR
    |--------------------------------------------------------------------------
    */

    const crearNoticia = async (formData) => {

        try {

            setError(null);

            const response =
                await crearNoticiaService(formData);

            /*
            Agregamos la noticia creada
            inmediatamente a la lista
            */

            if (response.data) {

                setNoticias((prev) => [
                    response.data,
                    ...prev,
                ]);

            }

            return response;

        } catch (error) {

            console.error(
                "Error al crear noticia:",
                error
            );

            setError(
                error.response?.data?.message ||
                "No se pudo crear la noticia."
            );

            throw error;
        }
    };


    /*
    |--------------------------------------------------------------------------
    | ACTUALIZAR
    |--------------------------------------------------------------------------
    */

    const actualizarNoticia = async (
        id,
        formData
    ) => {

        try {

            setError(null);

            const response =
                await actualizarNoticiaService(
                    id,
                    formData
                );

            /*
            Actualizamos la noticia
            dentro del estado
            */

            if (response.data) {

                setNoticias((prev) =>
                    prev.map((noticia) =>
                        noticia.id === id
                            ? response.data
                            : noticia
                    )
                );

            }

            return response;

        } catch (error) {

            console.error(
                "Error al actualizar noticia:",
                error
            );

            setError(
                error.response?.data?.message ||
                "No se pudo actualizar la noticia."
            );

            throw error;
        }
    };


    /*
    |--------------------------------------------------------------------------
    | ELIMINAR
    |--------------------------------------------------------------------------
    */

    const eliminarNoticia = async (id) => {

        try {

            setError(null);

            const response =
                await eliminarNoticiaService(id);

            /*
            Quitamos la noticia
            del estado
            */

            setNoticias((prev) =>
                prev.filter(
                    (noticia) =>
                        noticia.id !== id
                )
            );

            return response;

        } catch (error) {

            console.error(
                "Error al eliminar noticia:",
                error
            );

            setError(
                error.response?.data?.message ||
                "No se pudo eliminar la noticia."
            );

            throw error;
        }
    };


    /*
    |--------------------------------------------------------------------------
    | CARGAR AL ENTRAR
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        cargarNoticias();

    }, [cargarNoticias]);


    return {

        noticias,

        loading,

        error,

        cargarNoticias,

        crearNoticia,

        actualizarNoticia,

        eliminarNoticia,

    };
};


export default useNoticias;


 


